import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

/*
 * "Système U — Quiz — Bien manger" (Coopérative U survey, program su03): a daily
 * quiz in the MonMagasinU app, 1 session a day and at most 3 a week, every
 * completed session worth one ticket for a weekly €500 lottery. Three periods of
 * four weeks (Survey Project Passport, mg4). Weeks run Monday → Sunday; week 1
 * is go-live Tuesday 6 Oct → Sunday 11 Oct.
 *
 * Its own payload shape and page (features/survey), so `kind: 'survey'`. The
 * winners page sits beside it at `<path>/winners`.
 *
 * Step 1 = this UI. Until the pipeline exists, dev renders the design's sample
 * figures and a deployed build renders zeros with a "No live data" pill.
 */
export const systemeUSurveyConfig: DashboardConfig = {
  path: '/systeme-u/quiz-bien-manger',
  reportId: 'systeme-u-survey-2026',
  label: 'Système U · Quiz Bien manger',
  endsOn: '2026-12-13', // two seasons, 6 Oct → 13 Dec — archived from the day after
  kind: 'survey',
  // Prod backend is mngs01 on the EU cluster (passport, "Domains").
  apiBaseUrl: clusterBase('eu'),
};
